<section class="peer-panel">
   <!-- Header -->
   <div class="peer-panel__head">
      <div class="peer-panel__icon">
         <i class="fa fa-user-group"></i>
      </div>

      <div class="peer-panel__titles">
         <h3 class="peer-panel__title">
            Peer Input
            <span
               class="peer-count"
               *ngIf="submittedCount > 0">
               {{ submittedCount }} ready
            </span>
         </h3>
         <p class="peer-panel__sub">
            Ask a colleague at
            <strong>{{ practiceName || "this hospital" }}</strong>
            , or someone in your role at another hospital, to fill out a blank copy of this review. Only you see their answers
            <ng-container *ngIf="revieweeName">; {{ revieweeName }} does not</ng-container>
            .
         </p>
      </div>

      <button
         type="button"
         class="peer-btn"
         [class.peer-btn--active]="showSearch"
         (click)="toggleSearch()">
         <i
            class="fa"
            [class.fa-plus]="!showSearch"
            [class.fa-xmark]="showSearch"></i>
         {{ showSearch ? "Close" : "Request Input" }}
      </button>
   </div>

   <!-- Search -->
   <div
      class="peer-search"
      *ngIf="showSearch">
      <div class="peer-search__box">
         <i class="fa fa-magnifying-glass"></i>
         <input
            type="text"
            placeholder="Search by name"
            autocomplete="off"
            [(ngModel)]="searchText"
            (ngModelChange)="onSearchChange($event)" />
         <i
            *ngIf="searching"
            class="fa fa-spinner fa-spin"></i>
      </div>

      <div
         class="peer-search__hint"
         *ngIf="searchText.trim().length < 2">
         &nbsp;Type at least 2 letters.
      </div>

      <div
         class="peer-search__hint"
         *ngIf="searchText.trim().length >= 2 && !searching && !candidates.length">
         No one matches "{{ searchText.trim() }}".
      </div>

      <ul
         class="peer-results"
         *ngIf="candidates.length">
         <li *ngFor="let c of candidates">
            <span class="peer-avatar">{{ initials(c.displayName) }}</span>
            <span class="peer-who">
               <strong>{{ c.displayName }}</strong>
               <small>
                  {{ c.jobTitle }}
                  <ng-container *ngIf="c.practiceName">&nbsp;·&nbsp;{{ c.practiceName }}</ng-container>
               </small>
            </span>
            <span
               class="peer-chip"
               [class.peer-chip--role]="c.matchReason !== 'Same hospital'">
               {{ c.matchReason }}
            </span>
            <button
               type="button"
               class="peer-btn peer-btn--solid"
               [disabled]="sendingTo !== null"
               (click)="send(c)">
               {{ sendingTo === c.userId ? "Sending…" : "Send" }}
            </button>
         </li>
      </ul>
   </div>

   <!-- Requests -->
   <div
      class="peer-list"
      *ngIf="requests.length">
      <div
         class="peer-row"
         *ngFor="let r of requests; trackBy: trackById">
         <span
            class="peer-avatar"
            [class.peer-avatar--done]="r.status === 'Submitted'">
            {{ initials(r.peerName) }}
         </span>

         <span class="peer-who">
            <strong>{{ r.peerName }}</strong>
            <small *ngIf="r.status === 'Submitted'">
               <i class="fa fa-circle-check peer-ok"></i>
               Submitted {{ shortDate(r.submittedOn) }}
            </small>
            <small *ngIf="r.status !== 'Submitted'">
               <i class="fa fa-clock"></i>
               Asked {{ shortDate(r.requestedOn) }} · waiting for answers
            </small>
         </span>

         <span class="peer-row__actions">
            <ng-container *ngIf="r.status !== 'Submitted'">
               <button
                  type="button"
                  class="peer-icon-btn"
                  title="Copy their link"
                  (click)="copyLink(r)">
                  <i class="fa fa-link"></i>
               </button>
               <button
                  type="button"
                  class="peer-icon-btn peer-icon-btn--danger"
                  title="Cancel request"
                  (click)="remove(r)">
                  <i class="fa fa-xmark"></i>
               </button>
            </ng-container>

            <button
               *ngIf="r.status === 'Submitted'"
               type="button"
               class="peer-btn peer-btn--solid"
               (click)="openCopy(r)">
               <i class="fa fa-copy"></i>
               Review &amp; Copy
            </button>
         </span>
      </div>
   </div>
</section>

<!-- Copy dialog -->
<ng-container *ngIf="activeRequest">
   <div
      class="peer-overlay"
      (click)="closeCopy()"></div>

   <div
      class="peer-modal"
      role="dialog"
      aria-modal="true">
      <div class="peer-modal__head">
         <span class="peer-avatar peer-avatar--done">{{ initials(activeRequest.peerName) }}</span>
         <div class="peer-modal__titles">
            <div class="peer-modal__title">{{ activeRequest.peerName }}'s answers</div>
            <div class="peer-modal__sub">Check the answers you want. Each one you copy replaces your answer to that question.</div>
         </div>
         <button
            type="button"
            class="peer-modal__close"
            title="Close"
            (click)="closeCopy()">
            <i class="fa fa-xmark"></i>
         </button>
      </div>

      <div
         class="peer-modal__toolbar"
         *ngIf="!loadingDetail && copyGroups.length">
         <span class="peer-modal__count">
            <strong>{{ selectedCount }}</strong>
            of {{ allItems.length }} selected
         </span>
         <span class="peer-modal__links">
            <button
               type="button"
               (click)="selectAll(true)">
               Select all
            </button>
            <span class="peer-modal__divider"></span>
            <button
               type="button"
               (click)="selectAll(false)">
               Clear
            </button>
         </span>
      </div>

      <div class="peer-modal__body">
         <div
            class="peer-modal__state"
            *ngIf="loadingDetail">
            <i class="fa fa-spinner fa-spin"></i>
            &nbsp;Loading their answers…
         </div>

         <div
            class="peer-modal__state"
            *ngIf="!loadingDetail && !copyGroups.length">
            They didn't answer any questions.
         </div>

         <div
            class="peer-group"
            *ngFor="let g of copyGroups">
            <h4 class="peer-group__title">{{ g.title }}</h4>

            <label
               class="peer-item"
               *ngFor="let it of g.items; trackBy: trackByQuestion"
               [class.peer-item--on]="it.selected">
               <input
                  type="checkbox"
                  [(ngModel)]="it.selected" />
               <span class="peer-item__body">
                  <span class="peer-item__q">{{ it.label }}</span>
                  <span class="peer-item__a">
                     <span class="peer-tag">{{ firstName(activeRequest.peerName) }}</span>
                     <span class="peer-item__text">{{ it.theirs || "—" }}</span>
                  </span>
                  <span class="peer-item__a peer-item__a--mine">
                     <span class="peer-tag peer-tag--mine">Yours</span>
                     <span class="peer-item__text">{{ it.yours || "Not answered yet" }}</span>
                  </span>
               </span>
            </label>
         </div>
      </div>

      <div class="peer-modal__foot">
         <button
            type="button"
            class="peer-btn"
            (click)="closeCopy()">
            Cancel
         </button>
         <button
            type="button"
            class="peer-btn peer-btn--solid"
            [disabled]="!selectedCount"
            (click)="applyCopy()">
            <i class="fa fa-copy"></i>
            Copy {{ selectedCount || "" }} {{ selectedCount === 1 ? "answer" : "answers" }}
         </button>
      </div>
   </div>
</ng-container>
